import { combineReducers } from "redux";
import { userReducer } from "./user";
import userWheelsReducer from "./wheels";
import categoryReducer from "./categoryColors";
import colorReducer from "./userColors";
import { referralsReducer } from "./referrals";
import { analyticsReducer } from "./analytics";
import settingsReducer from "./segmentSettings";
import wallpapersReducer from "./wallpapers";
import wheelWallpaperReducer from "./wheelWallpaper";
import builderReducer from "./builder";
import segmentBuilder from "./segmentBuilder";
import deleteDialogReducer from "./dialog";
import moveBlockDialogReducer from "./moveBlockDialog";
import galleryReducer from "./gallery";
import generalDialog from "./generalDialog";
import betaTimeoutPopup from "./betaTimeoutPopup";
import codeblockDefaultStylesReducer from "./PrevStylesCopy/CodeblockDefaultStyles";
import wheelSettings from "./wheelSettings";
import galleryPopup from "./galleryPopup";
import hotbarReducer from "./newhotbar";
import colorPalette from "./colorPalette";
import createWheelPopupReducer from "./createWheelPopup";
import storageReducer from "./storage";
import notificationsSlice from "./notifications";
import dialogPopup from "./dialogPopup";
import upgradePopup from "./upgradePopup";
import aiWheelsReducer from "./aiWheels";
import subscriptionReducer from "./subscription";
import mobileViewDialogReducer from "./mobileViewDialog";
import nonAuthenticatedModalReducer from "./nonAuthenticatedModal";

const rootReducer = combineReducers({
  userProfile: userReducer,
  userWheels: userWheelsReducer,
  categoryColors: categoryReducer,
  userColors: colorReducer,
  referrals: referralsReducer,
  analytics: analyticsReducer,
  segmentSettings: settingsReducer,
  wallpapersReducer: wallpapersReducer,
  wheelWallpaperReducer: wheelWallpaperReducer,
  wheel: builderReducer,
  segmentBuilder: segmentBuilder,
  deleteDialog: deleteDialogReducer,
  moveBlockDialog: moveBlockDialogReducer,
  mobileViewDialog: mobileViewDialogReducer,
  gallery: galleryReducer,
  generalDialog: generalDialog,
  betaTimeoutPopup: betaTimeoutPopup,
  codeblockStyles: codeblockDefaultStylesReducer,
  wheelSettings,
  galleryPopup: galleryPopup,
  hotbar: hotbarReducer,
  colorPalette: colorPalette,
  createWheelPopup: createWheelPopupReducer,
  storage: storageReducer,
  notifications: notificationsSlice,
  dialogPopup,
  upgradePopup,
  aiWheels: aiWheelsReducer,
  subscription: subscriptionReducer,
  nonAuthenticatedModal: nonAuthenticatedModalReducer,
});

export default rootReducer;
